export default __webpack_public_path__ + "static/media/topMenu_bell.eaf91689.svg";